/**
 * A class representing layer to display an BasicMap with a name, a visibility
 * status and an [ol/layer/Layer](https://openlayers.org/en/latest/apidoc/module-ol_layer_Layer-Layer.html)
 *
 */
var Layer = function Layer(ref) {
  var name = ref.name;
  var olLayer = ref.olLayer;
  var visible = ref.visible;
  this.name = name;
  this.olLayer = olLayer;
  this.visible = typeof visible === 'undefined' ? true : visible;
  this.setVisible(this.visible);
};

Layer.prototype.init = function init(map) {
  this.map = map;
  map.addLayer(this.olLayer);
};

Layer.prototype.getName = function getName() {
  return this.name;
};

Layer.prototype.getVisible = function getVisible() {
  return this.visible;
};

Layer.prototype.changed = function changed() {
  this.olLayer.changed();
};

Layer.prototype.setStyle = function setStyle(style) {
  this.olLayer.setStyle(style);
};

Layer.prototype.setVisible = function setVisible(visible) {
  this.visible = visible;
  this.olLayer.setVisible(visible);
};

export default Layer;